<template>
  <v-dialog
    v-model="show"
    max-width="40vw"
    @click:outside="cancel"
  >
    <v-card
      flat
      class="pa-3 mt-2"
    >
      <v-card-title class="justify-center text-h5">
        {{ label }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          class="multi-col-validation mt-6"
        >
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="typeId"
                :items="vacancyTypesDropdown"
                :menu-props="{ maxHeight: '400' }"
                label="Тип"
                :rules="[rules.required, rules.enumRequired]"
                dense
                outlined
                persistent-hint
                hide-details
              ></v-select>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-checkbox
                v-model="isActive"
                label="Активен"
                hide-details
              ></v-checkbox>
            </v-col>

            <v-spacer></v-spacer>

            <v-col
              md="12"
              cols="24"
            >
              <translation-fields
                v-model="translations"
                :fields="translatedFields"
              />
            </v-col>

            <v-col cols="12">
              <v-btn
                color="primary"
                class="me-3 mt-4"
                @click="saveData"
              >
                Сохранить
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                class="mt-4"
                type="reset"
                @click="cancel"
              >
                Отмена
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiCheck, mdiClose } from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import DatePicker from '@/components/date-picker'
import { rules } from '@/helpers/validation'
import TranslationFields from '@/components/translation-fields'

export default {
  name: 'VacancyForm',
  components: { TranslationFields, DatePicker },
  props: ['save', 'show', 'cancellation', 'label'],
  data: () => ({
    icons: {
      mdiCheck,
      mdiClose,
    },
    translatedFields: [
      { key: 'name', label: 'Наименование', required: true },
      { key: 'description', label: 'Описание', rich: true },
    ],
    rules,
  }),
  computed: {
    ...mapFormHandlers('vacancy/form', [
      'translations',
      'typeId',
      'isActive',
    ]),
    ...mapGetters('dictionary', { vacancyTypesDropdown: 'vacancyTypesDropdown' }),
  },
  watch: {
    show(newValue) {
      if (newValue && this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
  },
  async mounted() {
    await this.fetchVacancyTypes()
  },
  methods: {
    cancel() {
      this.resetForm()
      this.cancellation()
    },
    ...mapActions('vacancy/form', ['resetForm']),
    ...mapActions('dictionary', {
      fetchVacancyTypes: 'fetchVacancyTypes',
    }),
    async saveData() {
      if (this.$refs.form.validate()) {
        await this.save()
        this.resetForm()
      }
    },
  },
}
</script>
